import { TransactionState } from '@app/store/domain';

export type RecordingFilters = {
  searchText: string;
};

export type SeriesFilters = {
  searchText: string;
};

export type SeriesType = {
  id?: string;
  name?: string;
  eventsCount?: number;
  registrants?: number;
  slug?: string;
  registrationsCount?: number | null;
  allowMultiEventRegistration?: boolean;
  status?: string;
  description?: string | null;
  timeStart?: string;
  timeEnd?: string;
  seriesImage?: {
    url?: string | null;
  }[];
  expired?: boolean;
  isLite?: boolean;
  venueType?: string;
  eventSeriesCount?: number;
  eventSeries?: {
    edges: {
      node: {
        id: string;
        eventsCount: number;
        name: string;
      };
    }[];
  };
};

export type State = {
  recordingInfo: {
    filters: RecordingFilters;
    isRecordingsLoaded: boolean;
    recordingsData: RecordingList & TransactionState;
  };
  seriesInfo: {
    filters: SeriesFilters;
    sortConfig: {
      name: string;
      reverseSort: boolean;
    };
    isLoading: boolean;
    error: string;
    seriesData: {
      data: SeriesType[];
      pagination: SeriesPageCursor;
    };
  };
};

export const defaultState: State = {
  recordingInfo: {
    filters: {
      searchText: '',
    },
    isRecordingsLoaded: false,
    recordingsData: {
      data: [],
      pagination: {
        next_cursor: null,
      },
      status: 'idle',
    },
  },
  seriesInfo: {
    filters: {
      searchText: '',
    },
    sortConfig: {
      name: 'name',
      reverseSort: false,
    },
    isLoading: false,
    error: '',
    seriesData: {
      data: [],
      pagination: {
        endCursor: null,
        hasNextPage: false,
      },
    },
  },
};

// API response for single Recording
export type Recording = {
  id: string;
  title: string;
  thumbnail: string | null;
  playable_url: string | null;
  status: string;
  started_at: string;
};

export type PageCursor = {
  next_cursor: string | null;
};

export type SeriesPageCursor = {
  endCursor: string | null;
  hasNextPage: boolean;
};

export type RecordingListResponse = {
  data: Recording[];
  pagination: PageCursor;
};

export type RecordingList = {
  data: Recording[];
  pagination: PageCursor;
};
